import { render, staticRenderFns } from "./TableHead.vue?vue&type=template&id=964e05fc&scoped=true&"
import script from "./TableHead.vue?vue&type=script&lang=js&"
export * from "./TableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964e05fc",
  null
  
)

export default component.exports